<template>
    <fieldset>
        <legend>
            <label>
                <input type="radio" name="shippingSource" @change="sourceChanged" checked> My available addresses ({{addressBook.length}})
            </label>
        </legend>
        <div v-if="enabled">
            <div class="checkbox">
                <label>
                    <input type="checkbox" name="addNewAddress" v-model="addNewAddress">
                    <span>
                        Neue Lieferadresse
                    </span>
                </label>
            </div>
            <div v-if="! addNewAddress">
                <select class="form-control" @change="selectAddreess">
                    <option v-for="(address, index) in addressBook" :key="address.id" :value="index">
                        {{index + 1}}. {{address.company}}, {{address.street}}, {{address.zip}} {{address.city}}, {{address.countryName}}
                    </option>
                </select>
            </div>
            <div v-else>
                <new-address v-model="address" :countries="countries" ref="newAddress"></new-address>
            </div>
        </div>
    </fieldset>
</template>

<script>

import {clone} from "lodash";
import NewAddress from './NewAddress';

export default {

    components: {
        NewAddress
    },
  
    props: {
        user: {
            required: true,
            default: null
        },
        countries: {
            required: true,
            default: []
        }
    },

    data() {
        return {
            enabled: true,
            address: clone(this.user),
            addNewAddress: false,
            loadingAddressBook: false,
            addressBook: [
                clone(this.user)
            ],
            newAddress: {
                company: '',
                street: '',
                city: '',
                zip: '',
                country: '',
                countryName: '',
            },
        }
    },

    computed: {

    },

    created() {

        this.loadAddressBook();

        App.event.listen('shipping.source.changed', ({who}) => {
            this.enabled = who == 'user';
            this.emitChange();
        });
        
    },

    methods: {
        
        loadAddressBook() {
            this.loadingAddressBook = true;
            new Form().get('/api/me/addressbook')
            .then(addressBook => {
                this.loadingAddressBook = false;
                if (addressBook.length) {
                    addressBook.unshift(clone(this.user));
                    
                    this.addressBook = addressBook;
                } else {

                }
            })
        },

        selectAddreess({target}) {
            let index = target.value;
            this.address = this.addressBook[index];
            this.emitChange();
        },

        sourceChanged() {
            App.event.fire('shipping.source.changed', { who: 'user' });
        },

        validate() {
            if (this.enabled) {
                return (
                    this.validField('company') &&
                    this.validField('street') &&
                    this.validField('city') &&
                    this.validField('zip') &&
                    this.validField('country')
                );
            } else {
                return true;
            }
        },

        validField(name) {
            return this.address[name].length > 0;
        },

        emitChange() {
            if (this.enabled) {
                this.$emit('change', {
                    address: clone(this.address),
                    isNew: this.addNewAddress
                });
            }
        }

    },

    watch: {

        addNewAddress() {
            this.address = this.addNewAddress ? clone(this.newAddress) : clone(this.addressBook).shift();
        },

        address: {
            deep: true,
            handler: function() { this.emitChange(); }
        }

    }

}
</script>
